import React from 'react';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useConsumerConfig } from '@homewise-solutions-inc/pkg-react-utils';
import { withSize } from 'react-sizeme';

import Landing from './components/Landing';
import './style.scss';

// import * as Sentry from "@sentry/react";
// import { Integrations } from '@sentry/tracing';
// import { Offline as OfflineIntegration } from "@sentry/integrations";
// import SentryRRWeb from "@sentry/rrweb";
// import { version } from '../package.json';

// if (process.env.NODE_ENV === 'production') {
// 	Sentry.init({
// 		dsn: process.env.REACT_APP_SENTRY_DSN,
// 		environment: process.env.REACT_APP_STAGE,
// 		release: version,
// 		integrations: [
// 			new Integrations.BrowserTracing(),
// 			new OfflineIntegration(
// 			{
// 				maxStoredEvents: 100
// 			}),
// 			// Disable RRWeb for now, reason: https://github.com/rrweb-io/rrweb/issues/816
// 			// new SentryRRWeb()
// 		],
// 		normalizeDepth: 5,
// 		tracesSampleRate: 0.5,
// 		ignoreErrors: [
// 			'paidAi',
// 			'widgetapp'
// 		],
// 		denyUrls: [
// 			/graph\.facebook\.com/i,
// 			/connect\.facebook\.net\/en_US\/all\.js/i,
// 			/www\.google-analytics\.com/i,
// 			/www\.google-analytics\.com\/all\.js/i,
// 			/cdn\.userway\.org/i,
// 			/api\.userway\.org\/api/i,
// 			// Chrome extensions
// 			/extensions\//i,
// 			/^chrome:\/\//i,
// 		]
// 	});
// }

const hwtheme = (primary = '#147bc9', isFontActive = true) => {
	return createTheme({
		typography: {
			fontFamily: isFontActive ? ['Merriweather Sans'].join(',') : '',
		},
		palette: {
			type: 'light',
			primary: {
				main: primary,
			},
			secondary: {
				main: '#326822',
			},
			background: {
				default: '#f5f7fa',
			},
		},
	});
};

const App = ({ size, index }) => {
	/**
   * Takes the config variable from the window object & rewrites the .homewise.banner property from an array
   * to a single object with configuration of the specified index from the props.
	 * 
	 * Aditionally, it adds the .homewise.partner property to the config object and ignores/removes all the
   * other widget configuration properties.
   */
	const transformedConfig =() => {
		const productTableConfig = Array.isArray(window?.homewise?.productTable) ? window.homewise.productTable[index] : null;

		let modifiedConfig = { partner: window?.homewise?.partner };

		if (productTableConfig !== null) {
			modifiedConfig['productTable'] = productTableConfig;
		}

		return modifiedConfig;
	}

	const consumerConfig = useConsumerConfig(transformedConfig(), false, index);

	return (
		// <Sentry.ErrorBoundary fallback={"An error has occurred"}>
			<div key={index}>
				<I18nextProvider i18n={i18n}>
					<ThemeProvider
						theme={hwtheme(
							consumerConfig?.productTable?.primaryColor,
							consumerConfig?.productTable?.font
						)}>
						<Landing config={consumerConfig} size={size} key={index} index={index} />
					</ThemeProvider>
				</I18nextProvider>
			</div>
		// </Sentry.ErrorBoundary>
	);
};

export default withSize()(App);
